<form [formGroup]="form">
  <div>
    <!-- Título -->
    <div class="custom-fields-title" *ngIf="showTitle">
      <div>
        <img src="../../../../../assets/icons/tag-icon.svg" />
        {{'CUSTOM_FIELDS.0' | translate}} <span class="optional-text">{{'CUSTOM_FIELDS.1' | translate}}</span>
      </div>
    </div>

    <!-- Descripción -->
    <div class="tag-description" *ngIf="showDescription">
      {{'CUSTOM_FIELDS.2' | translate}}
    </div>

    <!-- Etiqueta superior -->
    <div class="label-text">
      {{'CUSTOM_FIELDS.3' | translate}}
    </div>

    <!-- Dropdown -->
    <div class="dropdown-container">
      <div class="dropdown-input" #dropdownInput [ngClass]="{'open-dropdown': OpenDropdown}"
        (click)="OpenDropdown = !OpenDropdown">
        <p *ngIf="customFieldsFormArray.length === 0">{{'CUSTOM_FIELDS.4' | translate}}</p>

        <!-- Tags seleccionados -->
        <div class="tags-container" *ngIf="customFieldsFormArray.length > 0">
          <div class="tags" *ngFor="let ctrl of customFieldsFormArray.controls;  let i = index"
            [style.backgroundColor]="TagColorsBackground[i % TagColorsBackground.length].bkg"
            [style.color]="TagColorsBackground[i % TagColorsBackground.length].text"
            (click)="removeSelectedOption(ctrl.value, $event)">
            <p>{{ ctrl.get('Title')?.value }}</p>
            <img src="../../../assets/icons/close-modal-icon.svg" alt="">
          </div>
        </div>

        <img [ngClass]="{'rotate-icon': OpenDropdown}" src="../../../assets/icons/chevron-down.svg" alt="">
      </div>

      <!-- Opciones del dropdown -->
      <div class="dropdown-wrapper" #dropdownWrapper *ngIf="OpenDropdown">
        <div class="dropdown-list-container" *ngIf="CustomFileds?.length > 0">
          <ng-container *ngFor="let option of CustomFileds; let last = last">
            <div class="option-container" [ngClass]="{'selected-option': SelectedCustomFieldsIds.includes(option.Id)}"
              (click)="selectCustomField(option)">
              <div class="option-content">
                <p class="option-title">{{ option.Title }}</p>
                <p class="option-description">{{ option.Description }}</p>
              </div>
              <div class="option-checkbox-black"
                [ngClass]="{'option-checkbox-black-selected': SelectedCustomFieldsIds.includes(option.Id)}">
                <img *ngIf="SelectedCustomFieldsIds.includes(option.Id)" src="assets/icons/solid_check.webp" alt="" />
              </div>
            </div>
            <div class="split" *ngIf="!last"></div>
          </ng-container>
        </div>
        <div class="not-custom-fiels-message" *ngIf="!CustomFileds || CustomFileds.length === 0">
          {{'CUSTOM_FIELDS.9' | translate}}
        </div>
      </div>

      <!-- Campos de texto para inputs tipo string -->
      <div class="text-input-container" *ngIf="IsSomeSelectedFieldIsString">
        <p class="text-input-title">{{'CUSTOM_FIELDS.5' | translate}}</p>

        <!-- FormArray inputs -->
        <div formArrayName="customFields">
          <div *ngFor="let controlGroup of customFieldsFormArray?.controls; let i = index" [formGroupName]="i">
            <div *ngIf="controlGroup && controlGroup.get('Type')?.value === 'string'">
              <label class="text-input-label">
                {{ controlGroup.get('Title')?.value }}
              </label>
              <input class="form-text-input text-input"
                [ngClass]="{'form-text-input-error': controlGroup.invalid && controlGroup.touched}" type="text"
                formControlName="Value" [placeholder]="('CUSTOM_FIELDS.8' | translate)"
                [attr.maxlength]="controlGroup.get('MaxLength')?.value ?? 25">
              <div class="validation-container"
                [style]="controlGroup.get('Value')?.invalid && controlGroup.get('Value')?.touched ? 'justify-content: space-between;' : 'justify-content: flex-end;'">
                <div class="error-complete"
                  *ngIf="controlGroup.get('Value')?.invalid && controlGroup.get('Value')?.touched">
                  <img src="assets/icons/shield-exclamation-red.svg" alt="">
                  <p *ngIf="controlGroup.get('Value')?.errors?.['required']">{{'CUSTOM_FIELDS.6' | translate}}</p>
                </div>
                <div class="value-count">
                  {{controlGroup.get('Value')?.value.length}}/{{ controlGroup.get('MaxLength')?.value}}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>